export abstract class LoggerPort {
  abstract log(message: string, ...args: unknown[]): void;

  abstract warn(message: string, ...args: unknown[]): void;

  abstract error(message: string | Error, ...args: unknown[]): void;
}
